import React, { useEffect, useState } from "react";
import TableOfViewSchools from "./components/TableOfViewSchools";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import { Get_Schools_Fuzzy_Search } from "../api/Get_Schools_Fuzzy_Search";
import { Link } from "react-router-dom";
import SearchBar from "./components/SearchBar";
import DisplayExport from "../../../components/Exports/DisplayExport";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import deepFlattenToObject from "../../../../functions/deepFlattenToObject";
import GetClientAddress from "../../../../functions/GetClientAddress";

function ViewSchools() {
  const { logout } = StaffuseAuth();

  //-----------------------------Get Data---------------------------------------------

  // Assuming you have a state to store the fetched data
  const [schools, setSchools] = useState([]);
  //The below is the useEffect to fetch data from the backend

  useEffect(() => {
    if (localStorage.getItem("Team") === "PD") {
      Get_Schools_Fuzzy_Search(
        "Schools",
        "All_Schools",
        {
          searchPD: localStorage.getItem("Username"),
          limit: Number(200),
        },
        setSchools,
        logout
      );
    } else {
      Get_Schools_Fuzzy_Search(
        "Schools",
        "All_Schools",
        {
          limit: Number(200),
        },
        setSchools,
        logout
      );
    }
  }, []);

  //-----------------------------Components--------------------------------------------

  function DisplayGoToAddSchool() {
    //This is the flex item
    return (
      <Box
        component="main"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          maxWidth: "10%",
          maxHeight: "800px",
          flexGrow: 1,
          p: 1,
        }}
      >
        <Link
          to={`/Staff/ViewSchool/AddSchool`}
          target="_blank"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <button>View</button>
        </Link>
      </Box>
    );
  }

  //-----------------------------Export--------------------------------------------

  // let EC_Plus_Link = the array EC where every object is also given {Link: "/Staff/ViewEC/EC_id"}
  let Schools_Plus_Bursary_Link = schools.map((School) => {
    return {
      ...School,
      Bursary_Link: `${GetClientAddress()}Public/BursaryForm/${School._id}`,
    };
  });

  let Schools_Plus_Bursary_Link_Flattened = Schools_Plus_Bursary_Link.map(
    (One_School) => {
      return deepFlattenToObject(One_School);
    }
  );

  //-----------------------------Return--------------------------------------------

  return (
    <div style={{ backgroundColor: "#e5e5e5", minHeight: "93vh" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        <div
          name="space"
          style={{ width: "100%", height: "10px", flex: "0 1 auto" }}
        ></div>
        <SearchBar setSchools={setSchools} />
        <DisplayExport
          excelData={Schools_Plus_Bursary_Link_Flattened}
          fileName="Schools_Data"
        />
        <DisplayGoToAddSchool />
        <TableOfViewSchools style={{ flex: "0 1 auto" }} schools={schools} />
      </div>
    </div>
  );
}

export default ViewSchools;
